"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
function DefaultSpinner({ color }) {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: '64', height: '64', viewBox: '0 0 64 64', fill: 'none' }, { children: (0, jsx_runtime_1.jsx)("path", { d: 'M62.5 32C62.5 15.1553 48.8447 1.5 32 1.5C15.1553 1.5 1.5 15.1553 1.5 32C1.5 48.8447 15.1553 62.5 32 62.5', stroke: color, strokeWidth: '3', strokeLinecap: 'round' }) })));
}
exports.default = DefaultSpinner;
